import { render } from "./FreeList.vue?vue&type=template&id=8a494cb6&scoped=true"
import script from "./FreeList.vue?vue&type=script&lang=js"
export * from "./FreeList.vue?vue&type=script&lang=js"

import "./FreeList.vue?vue&type=style&index=0&id=8a494cb6&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a494cb6"]])

export default __exports__